import Hamburger from "./components/hamburger"
import React from "react"
import { render } from "react-dom"
import { ShyNav } from "./shy-nav"
import Selectr from "./selectr.min.js"
import Splide from "./splide.min.js"
import Video from "./splide-extension-video.min.js"

const bind = () => {
  const ref = getQueryStringValue("ref")
  if (ref != "") {
    Array.from(document.querySelectorAll("form"))
      .filter((f) => f.method == "post")
      .forEach((f) => (f.action = f.action + `?ref=${ref}`))
  }
}

function getQueryStringValue(key) {
  return decodeURIComponent(
    window.location.search.replace(
      new RegExp(
        "^(?:.*[&\\?]" +
          encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
          "(?:\\=([^&]*))?)?.*$",
        "i"
      ),
      "$1"
    )
  )
}

setTimeout(() => {
  bind()
  ShyNav.init("main-nav")
}, 100)

const hamburgerTarget = document.querySelectorAll(
  ".mobile-menu .menu-button"
)[0]
const hamburgerTargetFooter = document.getElementsByClassName("mobile-menu")[1]

if (hamburgerTarget) {
  render(<Hamburger />, hamburgerTarget)
}

if (hamburgerTargetFooter) {
  render(<Hamburger />, hamburgerTargetFooter)
}

const selectionIDs = [
  "volunteer-options",
  "volunteer-language-options",
  "volunteer-driving-options"
]
selectionIDs.forEach(id => {
  setTimeout(() => {
    const volunteerOptions = document.getElementById(id)
    if (volunteerOptions) {
      const placeholder = volunteerOptions.getAttribute("data-placeholder")
      const customClass = id
      new Selectr(volunteerOptions, {
        placeholder,
        customClass,
        searchable: false,
      })
    }
  }, 100)
})


if (document.querySelector('.splide')) {
  new Splide('.splide', {
    loop: true,
    perPage: 3,
    perMove: 3,
    gap: '40px',
    height: '340px',
    cover: true,
    trimSpace: true,
    breakpoints: {
      960: {
        perPage: 1,
        perMove: 1
      }
    }
  }).mount( window.splide.Extensions );
}

if (document.querySelector('.splide-gnd')) {
   new Splide('.splide-gnd', {
     loop: true,
	   perPage: 3,
     perMove: 1,
     heightRatio: 1 / 3,
	   lazyLoad: 'nearby',
     gap: '10px',
     height: '340px',
     breakpoints: {
       1350: {
         heightRatio: 1 / 2,
         perPage: 2,
       },
       768: {
         perPage: 1,
         heightRatio: 1
       }
     }
   }).mount();
}



// WEBPACK FOOTER //
// ./js/app.js